module.exports = __webpack_public_path__ + "img/look-icon .eed7500d.png";